// @flow @jsx h

import { h, Component } from 'preact'
import { bem } from '@nrk/dh-utils'
import { HtmlContent } from '../../../../shared/HtmlContent/index'

import type { Viewport } from '../../types'

import style from './index.css'

const nbsp = String.fromCharCode(160)

function cleanupText (text: string) {
  return text
    .replace('-post', '&#8209;post')
    .replace(new RegExp(nbsp, 'g'), ' ')
}

type Props = {
  viewport: Viewport,
  align: 'left' | 'right',
  title: string,
  content: string,
  byline: string,
  alt: string,
  date: string
}

type State = {}

export class DefaultCard extends Component<Props, State> {
  render () {
    const { viewport, align, title, content, byline, alt } = this.props
    const wrapperInlineStyle = {}

    if (viewport && viewport.height > -1) {
      wrapperInlineStyle.marginTop = `${viewport.height - 10}px`
    }

    return (
      <div className={bem(style.defaultCard, align)}>
        <div
          className={style.defaultCard__wrapper}
          style={wrapperInlineStyle}>
          <h2>{title}</h2>
          { content && <HtmlContent
            type={'p'}
            content={cleanupText(content)}
          /> }
          <p
            className={style.defaultCard__byline} >
            <div className='nrk-sr' role='img' alt={alt} />
            {byline}
          </p>
        </div>
      </div>
    )
  }
}
